export const mutation_add_sos = `
mutation addSos($fascicoloId: Int!, $date: timestamp!, $motivo: String!, $note: String!, $receiptId: String!, $reportedByUser: String!, $dateRicUif: date!) {
    insert_sos_one(object: {FascicoloId: $fascicoloId, Date: $date, Motivo: $motivo, Note: $note, ReceiptId: $receiptId, ReportedByUser: $reportedByUser, DateRicUif: $dateRicUif}) {
        Id
        Date
        Motivo
        Note
        ReceiptId
        ReportedByUser
        CreatedOn
        ModifiedOn
        CreatedBy
        ModifiedBy
        DateRicUif
    }
}`;
export const mutation_update_sos = `
mutation updateSos($id: Int!, $date: timestamp!, $motivo: String!, $note: String!, $receiptId: String!, $reportedByUser: String!, $dateRicUif: date!) {
    update_sos(where: {Id: {_eq: $id}}, _set: {Date: $date, Motivo: $motivo, Note: $note, ReceiptId: $receiptId, ReportedByUser: $reportedByUser, DateRicUif: $dateRicUif, ModifiedOn: "now()"}) {
        returning {
            Id
            Date
            Motivo
            Note
            ReceiptId
            ReportedByUser            
            CreatedOn
            ModifiedOn
            CreatedBy
            ModifiedBy
            DateRicUif
        }
    }
}`;
export const mutation_delete_sos = `
mutation deleteSos($id: Int!) {
    delete_sos(where: {Id: {_eq: $id}}) {
        affected_rows
    }
}`;